import { inject } from '@angular/core';
import {
  CanActivateFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { AuraAuthService } from '@digital-platform/aura-authentication/services';

export const PermissionGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean | UrlTree> => {
  const auraAuthService = inject(AuraAuthService);
  const router = inject(Router);

  const requiredPermissions =
    (route.data['requiredPermissions'] as string[]) || [];
  const logicOperator = (route.data['operator'] as 'AND' | 'OR') || 'AND';

  try {
    await firstValueFrom(auraAuthService.getAllSessionData(true));

    if (auraAuthService.isAuthorized(requiredPermissions, logicOperator)) {
      return true;
    }
  } catch (error) {
    console.error('Error fetching session data:', error);
  }

  const fallbackRoute = route.data['fallbackRoute'] as string;
  return fallbackRoute
    ? router.createUrlTree([fallbackRoute], {
        queryParams: route.data['fallbackQueryParams'] || {},
      })
    : router.createUrlTree(['/']);
};
